import { Segment } from '~src/interfaces/segment.interface';
import { ManagersSelectionPostData } from '~src/services/api/pulseCheck';
import { ContentLocalesI } from './session.types';
import { TopicSubject } from './topic.interface';

export interface Question {
  answer?: AnswerI;
  comments: CommentOptions;
  createdAt: string;
  customComments: boolean;
  customScale: boolean;
  description: ContentLocalesI;
  framework: boolean;
  howToImprove: ContentLocalesI;
  howToImproveSelf: ContentLocalesI;
  id: string;
  originalDescription: ContentLocalesI;
  originalSelfTitle: ContentLocalesI;
  originalTitle: ContentLocalesI;
  scaleId: string;
  scaleVersionId: string;
  scale_version_id: string;
  selfTitle: ContentLocalesI;
  subject: TopicSubject;
  title: ContentLocalesI;
  topicId: string;
  updatedAt: string;
  isCommentEnabled: boolean;
}

export interface ESQuestion {
  // the question interface from reporting
  created_at: string;
  description: ContentLocalesI;
  how_to_improve: ContentLocalesI;
  how_to_improve_self: ContentLocalesI;
  how_to_improve_threshold: number;
  id: string;
  position: number;
  self_text: ContentLocalesI;
  text: ContentLocalesI;
  topic_id: string;
  updated_at: string;
}

export function questionToESQuestion(question: Question): ESQuestion {
  return {
    created_at: question.createdAt,
    description: question.description,
    how_to_improve: question.howToImprove,
    how_to_improve_self: question.howToImproveSelf,
    how_to_improve_threshold: 0,
    id: question.id,
    position: 0,
    self_text: question.selfTitle || question.originalTitle,
    text: question.title,
    topic_id: question.topicId,
    updated_at: question.updatedAt,
  };
}

export interface CardI {
  about: Segment | null;
  answer: AnswerI;
  createdAt: string;
  id: string;
  question: Question;
  selfAssessment: boolean;
  submitted: boolean;
  updatedAt: boolean;
  mandatory: boolean;
}

export interface AnswerI {
  answer: number | null;
  scaleVersionId: string | null;
  comment?: string | null;
  forceRating?: boolean;
  answeredAt?: string;
  multipleChoiceAnswers?: number[];
}

export function emptyAnswer(): AnswerI {
  return {
    answer: null,
    scaleVersionId: null,
    comment: null,
  };
}

export interface AnswerValue {
  comment: string | null;
  rating: number | number[] | null;
}

export interface SelectionValue {
  selectedPeople: Segment[];
  postData: ManagersSelectionPostData;
}

export enum CardDirection {
  Next = 'next',
  Prev = 'prev',
  Previous = 'previous',
}

export enum CommentOptions {
  Optional = 'optional',
  Mandatory = 'mandatory',
}
